export const CREATE_UPLOAD_URL = `
  mutation createUploadUrl($removeOpacity: Boolean!, $organization: String!) {
    createUploadUrl(input: { clientMutationId: "1", removeOpacity: $removeOpacity, organization: $organization }) {
      clientMutationId
      url
      params
    }
  }
`;
